import { render, staticRenderFns } from "./IndividualScoring.vue?vue&type=template&id=0f04ddf9&"
import script from "./IndividualScoring.vue?vue&type=script&lang=js&"
export * from "./IndividualScoring.vue?vue&type=script&lang=js&"
import style0 from "./IndividualScoring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports